module.exports = __webpack_public_path__ + "img/menu.7e87b4d9.svg";